exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content_raw__openai{display:flex;margin-top:10px;align-items:center;justify-content:space-between}.recipe_no_conversion{align-items:center;border:2px solid #fa6422;display:flex;font-weight:'700';gap:8px;padding:4px}\n", ""]);

// exports
exports.locals = {
	"content_raw__openai": "content_raw__openai",
	"recipe_no_conversion": "recipe_no_conversion"
};